import { RestaurantTeamListFull } from "@/screens/restaurants/details/restaurant.team.list";
import { Stack, useLocalSearchParams } from "expo-router";

export default function FullList() {
  const { orgId } = useLocalSearchParams<{ orgId: string }>();

  return (
    <>
      <Stack.Screen options={{ title: "Team" }} />
      <RestaurantTeamListFull organizationId={orgId} />
    </>
  );
}
